import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActiveModal } from '@rocketfinancialcorp/rocket-ui/modal';
import { RktButtonDirective } from '@rocketfinancialcorp/rocket-ui/button';
import { RktIconComponent } from '@rocketfinancialcorp/rocket-ui/icon';

@Component({
  selector: 'app-generate-token-modal',
  templateUrl: 'generate-token-modal.component.html',
  standalone: true,
  imports: [CommonModule, RktButtonDirective, RktIconComponent],
})
export class GenerateTokenModalComponent {
  activeModal = inject(ActiveModal);

  copyFlag = false;

  accessToken!: string;

  errorMessage = '';

  modalInitData({ accessToken }: { accessToken: string }) {
    this.accessToken = accessToken;
  }

  copyToClipboard() {
    if (!this.copyFlag) {
      this.copyFlag = true;
      navigator.clipboard.writeText(this.accessToken);
      setTimeout(() => {
        this.copyFlag = false;
      }, 1000);
    }
  }
}
